import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import { Container } from "./styles";
import SearchBar from "../../general/SearchBar";
import SearchInput from "../../general/SearchInput";
import { useHistory } from "react-router-dom";
import { useModal } from "../../../hooks/useModal";
import useNotifications from "../../../hooks/useNotification";
import Modal from "../../general/Modal";
import CustomNotification from "../../general/CustomNotification";
import CustomButton from "../../general/CustomButton";

const HeaderFilter = ({
  searchBar,
  placeholderSearchBar,
  onSearchChange,
  showAddWishlist,
  onAddWishlist,
  onDeleteWishlist,
  onUpdateWishlist,
  wishlistId
}) => {
  const [searchValue, setSearchValue] = useState("");
  const inputRef = useRef(null);
  const history = useHistory();
  const { modalData, openModal, closeModal, handleCancelClick } = useModal();
  const { notifications, addNotification, deleteNotification } = useNotifications();
  
    const handleSearch = (e) => {
        const name = e.target.value;
        setSearchValue(name);
        onSearchChange(name);
      };

  const handleAdd = () =>{
    openModal({
      className:"modal-add",
      title: 'Crear Wishlist',
      text: 'Ingresa el nombre para tu wishlist',
      customComponent: (
        <input className="input-wishlist" ref={inputRef}/>
      ),
      showAccept:false,
      showCancel:true,
      onCancelClick: () => {
        closeModal();
      },
      buttons: [
        {
          label: "Guardar",
          onClick: () => {
            const wishlistName = inputRef.current?.value || ""; 
            if (wishlistName.trim()) {
              onAddWishlist(wishlistName, addNotification);
            } else {
              addNotification('error','El nombre de la wishlist no puede estar vacío');
            }
            closeModal();
          },
          className: "btn-guardar",
        },
      ]
    });
  }

  return (
    <Container>
      <div className="container-view">
        {searchBar && (
          <SearchInput
            placeholder={placeholderSearchBar}
            value={searchValue}
            onChange={handleSearch}
          />
        )}
        {showAddWishlist && (
            <CustomButton 
                className="add-wishlist"
                onClick={handleAdd}
                icon="add"
                variant="gray"
                showTooltip
                tooltipText="Crear una wishlsit"
                iconOnly
            />
        )}
      </div>
      <Modal {...modalData} onClose={handleCancelClick} />
      <CustomNotification
        open={notifications.length > 0}
        alerts={notifications}
        deleteNotification={deleteNotification}
      />
    </Container>
  );
};

HeaderFilter.defaultProps = {
  searchBar: false,
  placeholderSearchBar: "Buscar",
  onSearchChange: () => {},
  showAddWishlist: true
};

HeaderFilter.propTypes = {
  searchBar: PropTypes.bool,
  placeholderSearchBar: PropTypes.string,
  onSearchChange: PropTypes.func,
  showAddWishlist: PropTypes.bool,
  onAddWishlist: PropTypes.func.isRequired, 
  wishlistId: PropTypes.string,
};

export default HeaderFilter;
